<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.import", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
              {{ $t("Import.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-card
                max-height="240"
                v-if="material_album && material_album.length > 0"
              >
                <v-carousel hide-delimiters cycle height="200">
                  <v-carousel-item
                    v-for="(item, i) in material_album"
                    :key="i"
                    :src="item"
                    @click.stop="$showFullscreenImages(material_album, i)"
                  >
                    <v-tooltip right v-if="item">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="secondary"
                          class="pa-2 float-right"
                          @click.stop="removeFromImages(i)"
                        >
                          fa-times
                        </v-icon>
                      </template>
                      <span> {{ $t("Material.delImg") }}</span>
                    </v-tooltip>
                  </v-carousel-item>
                </v-carousel>
              </v-card>
              <v-file-input
                ref="material_imgs_file"
                show-size
                counter
                small-chips
                multiple
                suffix
                prepend-icon="fa-camera"
                accept="image/png, image/jpeg"
                persistent-hint
                :placeholder="$t('Material.imgsPlaceholder')"
                :rules="imgsRules"
                v-model="material_imgs_file"
              >
              </v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="submit()">
          {{ $t("Material.Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import Materials from "@/api/materials";

export default {
  name: "ImportExcelDialog",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    tipDetails: Array,
  },

  data: () => ({
    dialog: false,
    material_album: [],
    material_imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 5000000).length == 0 ||
        i18n.t("Material.Import.imgsHint"),
    ],
  }),
  methods: {
    removeFromImages(i) {
      this.material_album.splice(i, 1);
      this.material_imgs_file.splice(i, 1);
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查一下图片上传的error，拒绝上传
      if (this.$refs.material_imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      Materials.imagesUpload(this.material_imgs_file)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("Material.Import.images")])
              );
              this.dialog = false;
              this.$emit("refresh");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.material_album = [];
          this.material_imgs_file = [];
        }
        this.$emit("input", this.dialog);
      },
    },
    material_imgs_file: {
      handler() {
        if (this.material_imgs_file) {
          this.material_album = [];
          this.material_imgs_file.forEach((img, i) => {
            var reader = new FileReader();
            reader.readAsDataURL(img);
            let that = this;
            reader.onload = function () {
              that.material_album.splice(i, 0, this.result);
            };
          });
        } else {
          this.material_album = [];
        }
      },
    },
  },
};
</script>